/*  
  TODO: TO BE DEPRECATED: This file doesn't seem to be in use anymore for Flights team.
  If packages team doesn't use this, we can remove it
*/
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Box, Text, getPaletteColor } from 'pcln-design-system'

const StyledTooltip = styled(Box)`
  opacity: ${(props) => (props.isHovered ? 1 : 0)};
  visibility: ${(props) => (props.isHovered ? 'visible' : 'hidden')};
  transition: opacity 200ms ease-out;
  position: absolute;
  bottom: 100%;
  margin-bottom: 10px;
  ${(props) => {
    if (props.tipPosition === 'right') {
      return 'right: 0;'
    }

    if (props.tipPosition === 'left') {
      return 'left: 0;'
    }
    return 'left: 50%; transform: translateX(-50%);'
  }};
`

const Message = styled(Text.p)`
  white-space: nowrap;
  box-shadow: ${(props) => props.theme.shadows['2xl']};
  border-radius: ${(props) => props.theme.radius}px;

  ${(props) => props.theme.flyQueries.desktoplg} {
    font-size: 12px;
  }
`

const BottomTip = styled.div`
  position: absolute;
  top: 100%;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid ${(props) => getPaletteColor(props.color)(props)};
  background-color: ${(props) => getPaletteColor(props.color)};
  ${(props) => {
    if (props.tipPosition === 'right') {
      return 'right: 16px;'
    }

    if (props.tipPosition === 'left') {
      return 'left: 16px;'
    }

    return 'right: 50%; transform: translateX(50%);'
  }};
`

export default function FlyHoverTooltip({ isHovered, tooltipContent, color, tipPosition }) {
  return (
    <StyledTooltip
      isHovered={isHovered}
      tipPosition={tipPosition}
      data-test='fly-hover-tooltip'
      data-testid='fly-hover-tooltip'
    >
      <Message p='10px' bg={color} fontSize={11} color={'background.lightest'}>
        {tooltipContent}
      </Message>
      <BottomTip
        color={color}
        tipPosition={tipPosition}
        data-test='fly-hover-tooltip-tip'
        data-testid='fly-hover-tooltip-tip'
      />
    </StyledTooltip>
  )
}

FlyHoverTooltip.defaultProps = {
  color: 'text.base', // even though this is the background-color. `Text` is navy blue
}

FlyHoverTooltip.propTypes = {
  isHovered: PropTypes.bool,
  tooltipContent: PropTypes.string,
  tipPosition: PropTypes.oneOf(['right', 'left', 'center']),
  color: PropTypes.string,
}
